import LicenseData from './LicenseData.container';
export default LicenseData;
